<template>
    <div class="page_item flex" :class="ecgItemBgClass[itemIndex%2]" @click="doItemClick">
    <div class="flex-between ecg_list_item">
        <div class="flex-align-center">
            <div class="ecg_list_red_bg" v-show="showFlag"></div>
            <p class="ecg_p_text_1" :class="itemClass">{{avgEcgHeart}}</p>
            <p class="ecg_p_text_2" :class="itemClass">bpm</p>
            <div v-for="( aiResultItem, aiResultIndex ) in aiEcgResult " :key="aiResultIndex">
                <p class="ecg_p_text_2" :class="itemClass">{{aiResultItem}}</p>
            </div>
        </div>
        <div class="flex-align-center">
            <p class="ecg_p_text_1" :class="itemClass">{{aiEcgTime}}</p>
            <img src="../../assets/radio_button_n_2x.png" v-show="!showFlag"/>
            <img src="../../assets/radio_button_click_2x.png" v-show="showFlag"/>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
    name: "EcgListItem",
    props:[
        'avgEcgHeart',
        'aiEcgResult',
        'aiEcgTime',
        'itemIndex',
        'showFlag',
    ],
    data(){
        return{
            itemClass:[],
            ecgItemBgClass:["ecg_list_bg_1","ecg_list_bg_2"],
        }
    },


    computed: {
        ...mapGetters([
            "this.$store.state.ecgItemIndex"
        ])
    },

    mounted(){
    },
    methods:{
        doItemClick(){
        },
        ...mapMutations({
            setIndex: "ecg/SET_ECG_ITEM_INDEX",
        })
    }
}
</script>

<style lang="less" scoped>
@import "../../views/style/base.less";
.page_item {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 1920px;
    padding-left: auto;
    background-color: #EBEEEE;
}
.ecg_list_item {
    margin-top: .8rem;
    margin-bottom: .8rem;
    height: 100%;
    padding: 0 .2rem;
}

.ecg_p_text_1{
    padding-left: .5rem;
    padding-right: .5rem;
    min-width: 30px;
}
.ecg_p_text_2{
    padding-left: .5rem;
    text-align: center;
}

.ecg_list_red_bg{
    width: .2rem;
    height: 100%;
    background-color: #F65D5D;
    margin-right: .5rem;
}

.ecg_list_bg_click_1{
    color: #F65D5D;
}
.ecg_list_bg_click_2{
    color: #343434;
}

.ecg_list_bg_1{
    background-color: #EBEEEE;
}

.ecg_list_bg_2{
    background-color: #fff;
}
</style>